<template>
  <div class="CAlarmItem">
      <el-form-item v-if="isShow === 'true'" :label="label" :prop="prop">
        <el-row >
            <el-col :span="12">
              <el-row>
                  <el-col :span="12">
                      <el-input
                          v-model="aModel"
                          placeholder=""
                      >
                      </el-input>
                  </el-col>
                  <el-col :span="8">
                      <div style="margin-left: 10px">{{company}}</div>
                  </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
                <el-checkbox v-model="isAlarm" label="是否告警"></el-checkbox>
                <el-checkbox v-model="isSendSMS" label="告警短信"></el-checkbox>
                <el-checkbox v-model="isStopCharging" label="自动停充"></el-checkbox>
            </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-else-if="isShow === 'false'" :label="label">
        <el-row >
            <el-col :span="12">
               <div style="margin-left: 10px">{{aModel}} {{company}}</div>
            </el-col>
            <el-col :span="12">
                <el-checkbox v-model="isAlarm" label="是否告警"></el-checkbox>
                <el-checkbox v-model="isSendSMS" label="告警短信"></el-checkbox>
                <el-checkbox v-model="isStopCharging" label="自动停充"></el-checkbox>
            </el-col>
        </el-row>
      </el-form-item>
  </div>
</template>

<script>
export default {
  name: "CAlarmItem",
  props: {
    label: {
      type: String
    },
    aModel: {
      type: Object,
      default() {}
    },
    isAlarm: {
      type: Boolean,
      default() {
        return false
      }
    },
    isSendSMS: {
      type: Boolean,
      default() {
        return false
      }
    },
    isStopCharging: {
      type: Boolean,
      default() {
        return false
      }
    },
    company: {
      type: String 
    },
    prop: {
      type: String 
    },
    isShow: {
      type: String
    }
  },
  data() {
    return {
      
    };
  },
  created: function() {},
  computed: {},
  watch: {
  },
  methods: {
    
  },
};
</script>

<style scoped lang="less">
</style>




// WEBPACK FOOTER //
// src/components/CAlarmItem/index.vue